import { connect } from '@atlassian/jira-react-redux';
import { getCustomFiltersSettingsUrl } from '../../common/urls';
import { getRapidViewId, getProjectKey } from '../../state/selectors/app';
import { canEditBoardConfig } from '../../state/selectors/permissions';
import type { State } from '../../state/types';
import CustomFilterFailed from './view';

type StateProps = {
	canAccessCustomFilterSettings: boolean;
	customFiltersSettingsUrl: string;
};

const mapStateToProps = (state: State): StateProps => ({
	canAccessCustomFilterSettings: canEditBoardConfig(state),
	customFiltersSettingsUrl: getCustomFiltersSettingsUrl(
		getProjectKey(state),
		getRapidViewId(state),
	),
});

export default connect(mapStateToProps, {})(CustomFilterFailed);
